import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "John Doe",
    title: "Homeowner",
    content:
      "WoodCraft's team provided excellent service! Their attention to detail and quality craftsmanship exceeded my expectations.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Jane Smith",
    title: "Homeowner",
    content:
      "I am extremely satisfied with the woodwork installed by WoodCraft. The whole process was seamless and hassle-free.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "Michael Thompson",
    title: "Builder",
    content:
      "The team at WoodCraft is professional and knowledgeable. I highly recommend their services to anyone looking for quality woodwork.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Emily Johnson",
    title: "Architect",
    content:
      "WoodCraft's commitment to quality and customer satisfaction is commendable. I am delighted with the results!",
  },
];

export default testimonials;